module.exports = __webpack_public_path__ + "static/media/temp-mass.2e071181.png";